import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "timerIndicator",
    standalone: false
})
export class TimerIndicatorPipe implements PipeTransform {

    transform(value: number, ...args: any[]): any {
        if (value === undefined || value === null || isNaN(value)) {
            return '0:00';
        }
        const minutes: number = Math.floor(value / 60);
        const seconds: number = (value - minutes * 60);
        
        return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
    }
};